module.exports = __webpack_public_path__ + "assets/save.5be2e7c377eed892fb9f3e5fc82f3591.svg";


//////////////////
// WEBPACK FOOTER
// ./img/save.svg
// module id = 1009
// module chunks = 0